import { render, staticRenderFns } from "./SoldAsset.vue?vue&type=template&id=3c6543a4&scoped=true&"
import script from "./SoldAsset.vue?vue&type=script&lang=js&"
export * from "./SoldAsset.vue?vue&type=script&lang=js&"
import style0 from "./SoldAsset.vue?vue&type=style&index=0&id=3c6543a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c6543a4",
  null
  
)

export default component.exports